<script>
  import { fade } from "svelte/transition";
  import Title from "../components/Title.svelte";
  import { redirect } from "../pager";
  import Alert from "../components/Alert.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  import Placeholder from "../components/placeholder/Placeholder.svelte";

  //liblary
  import axios from "axios";
  import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });
  

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert;
  $: alert = []; 
  let itemsDisplay = false;
  let items = []; 
  axios
    .get(settings.url + "/sipade/akun", {
      params: {
        authorization: settings.token,
      },
    })
    .then(function (response) {
      items = response.data;
      itemsDisplay = true;
    })
    .catch(function (error) {
      if (error.response.status == 401) {
        localStorage.removeItem("t");
        redirect("/login");
      } else {
        if (error.response.data.message) {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: error.response.data.message,
              color: "orange",
            },
          ];
        } else {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: "Anda belum terhubung dengan baik",
              color: "orange",
            },
          ];
        }
      }
    });

  function loadingBtn(e) {
    let el = this;
    el.setAttribute("disabled", "disabled");
    let reset = e.srcElement.innerHTML;
    this.innerHTML = "Memproses...";
    setTimeout(() => {
      el.innerHTML = reset;
      el.removeAttribute("disabled");
    }, 10000);
  }

  let require;
  $: require = {
    pass1: "",
    pass: "",
  };

  let number;
  $: number = { 
  };
  //#FORM Data Payload

  let errorForm;
  $: errorForm = errorForm;
  function validator() {
    errorForm = [];
    for (var k in require) {
      if (document.getElementById(k + "-labelwarning")) {
        document.getElementById(k + "-labelwarning").style = "";
      }
      if (document.getElementById(k + "-warning")) {
        document.getElementById(k + "-warning").style.display = "none";
        document.getElementById(k + "-warning").innerHTML = "";
      }
      if (
        require[k] !== undefined &&
        require[k] !== null &&
        require[k] !== "" &&
        require[k] !== false
      ) {
        
      } else {
        errorForm = [...errorForm, { field: k, message: "Mohon diisi" }];
        if (document.getElementById(k + "-warning")) {
          document.getElementById(k + "-warning").style.display =
            "inline-block";
          document.getElementById(k + "-warning").innerHTML = "Mohon diisi";
        }
        if (document.getElementById(k + "-labelwarning")) {
          document.getElementById(k + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    for (var n in number) {
      document.getElementById(n + "-warning").style.display = "none";
      document.getElementById(n + "-labelwarning").style = "";
      document.getElementById(n + "-warning").innerHTML = "";
      if (/^\+?([0-9]\d*)$/.test(number[n])) {
        
      } else {
        errorForm = [
          ...errorForm,
          { field: n, message: "Pastikan Hanya Angka" },
        ];
        if (document.getElementById(n + "-warning")) {
          document.getElementById(n + "-warning").style.display =
            "inline-block";
          document.getElementById(n + "-warning").innerHTML =
            "Pastikan Hanya Angka";
        }
        if (document.getElementById(n + "-labelwarning")) {
          document.getElementById(n + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    
    if (errorForm.length > 0) { 
      return false;
    } else {
      return true;
    }
  }
  function handleSubmit() {
    let valid = validator();
    if (valid) {
      axios
        .post(settings.url + "/sipade/akun?authorization=" + settings.token, { 
          upass: require.pass,
          upass1: require.pass1,
        })
        .then(function (response) {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: response.data.message,
              color: "green",
            },
          ];

          
    settings = {
      url: "https://api.dekatan.com",
      loggedin: false,
    };

    session.update((n) => settings);
    localStorage.removeItem("t");
            
          setTimeout(() => {
            redirect("/login");
          }, 3000);
        })
        .catch(function (error) {
          if (error.response.status == 401) {
            localStorage.removeItem("t");
            
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: "Anda mungkin harus login kembali",
                color: "orange",
              },
            ];
          } else {
            if(error.response.data.error){
              console.log(error.response.data.error)
              for (var e in error.response.data.error) {  
                alert = [
              ...alert,
              {
                title: "Dekatan",
                message: error.response.data.error[e].message,
                color: "orange",
              },
            ];
              }
          }
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: error.response.data.message,
                color: "orange",
              },
            ];
          }
        });
    } else {
      
      alert = [
        {
          title: "Dekatan",
          message: "Ada kolom yang belum Terisi dengan benar",
          color: "orange",
        },
      ];
    } 
  }
 
</script>
<svelte:head>
<title>Kelola Akun - Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 left-0 right-0 z-10 w-full px-2 mb-10 lg:left-auto lg:w-3/12">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
<Navigationbar
  backbtn="true"
  message={navigation['message']}
  title="Profil Anda" />
<main transition:fade class="container px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0">
  <div class="pt-2 mx-auto my-5 lg:mt-10 lg:my-0">
    {#if itemsDisplay == false}
      <div class="max-w-lg mx-auto rounded-lg">
        <div class="w-full mx-auto my-5 lg:my-0">
          <div class="w-full mx-auto mb-2">
            <div class="p-10 bg-white rounded-md shadow-md">
              {#each [1] as l}
                <Placeholder type="6" />
              {/each}
            </div>
          </div>
        </div>
      </div>
    {:else}
      <div class="max-w-lg mx-auto rounded-lg">
        <div class="w-full mx-auto my-5 lg:my-0">
          
          <div class="w-full mx-auto mb-2">
            <div class="p-10 pt-5 bg-white rounded-md shadow-md">
    <Title subtitle="Perbaharui Kata Sandi Kamu" tipe=2 title="Kata Sandi Akun" />
              <form class="w-full" on:submit|preventDefault={handleSubmit}>
                <div id="stepcontID1" class="block stepcontID">
                  {#if errorForm}
                    {#if errorForm.length > 0}
                    <div
                      class="w-full p-2 mt-4 mb-5 text-sm italic text-red-500 border border-l-4 border-red-500 rounded-lg">
                      Mohon isi dengan benar,
                      <br />
                      {#each errorForm as e}
                        - Kolom
                        <b>{document.getElementById(e.field + '-labelwarning').innerText}</b>
                        {e.message}<br />
                      {/each}
                    </div>
                  {/if} 
                  {/if}
                  <section class="mt-10">
                    <label
                      for="pass1"
                      class="relative block text-sm font-light">
                      <input
                        autocomplete="off"
                        minlength="10"
                        id="pass1"
                        type="password"
                        name="pass1"
                        class="w-full text-sm placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                        placeholder="Kata sandi baru yang kamu inginkan"
                        bind:value={require.pass1} />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white rounded"
                        id="pass1-labelwarning">Kata Sandi Baru</span>
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="pass1-warning" />
                    </label>
                  </section>
                  <p class="mt-5 text-sm text-center">
                    Konfirmasi kata sandi untuk memastikan ini adalah kamu
                  </p>

                  <section class="mt-5">
                    <label
                      for="utelp"
                      class="relative block text-sm font-light">
                      <input
                        autocomplete="off"
                        type="password"
                        id="pass"
                        name="pass"
                        class="w-full text-sm placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                        placeholder="Kata sandi..."
                        bind:value={require.pass} />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white rounded"
                        id="pass-labelwarning">Kata Sandi Saat Ini</span>
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="pass-warning" />
                    </label>
                  </section>

                  <button
                    type="button"
                    class="w-auto px-10 py-2 my-5 text-gray-100 bg-green-600 rounded text-1xl focus:bg-gray-500 focus:outline-none"
                    on:click={loadingBtn}
                    on:click={handleSubmit}>
                    SIMPAN
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    {/if}
  </div>
</main>
